module.exports = {
  bank: 'banks',
  country: 'countries',
  contractType: 'contractTypes',
  currency: 'currencies',
  customs: 'customs',
  customsPatent: 'customsPatents',
  customsShipperNumber: 'customsShipperNumbers',
  deductionType: 'deductionTypes',
  hourType: 'hourTypes',
  jobRisk: 'jobRisks',
  laborType: 'laborTypes',
  month: 'months',
  otherPaymentType: 'otherPaymentTypes',
  payLeaveType: 'payLeaveTypes',
  paymentForm: 'paymentForms',
  paymentMethod: 'paymentMethods',
  paymentPeriodicity: 'paymentsPeriodicity',
  payrollType: 'payrollTypes',
  perceptionType: 'perceptionTypes',
  productServiceKey: 'productServiceKeys',
  regimeType: 'regimeTypes',
  relationType: 'relationTypes',
  resourceOrigin: 'resourceOrigins',
  state: 'states',
  tax: 'taxes',
  taxRateOrFee: 'taxRateOrFees',
  taxRegime: 'taxRegimes',
  cfdiUse: 'cfdiUses',
  unitKey: 'unitKeys',
  voucherType: 'voucherTypes',
  zipCode: 'zipCodes',
};
